// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"508":"b6be905a","604":"1a22e60e","776":"e67134bc"}[chunkId] + ".css";
};